module.exports = __webpack_public_path__ + "img/volume-slash.128f57f3.svg";